import { render, staticRenderFns } from "./CustomerPageVisiosList.vue?vue&type=template&id=9fab7908&"
import script from "./CustomerPageVisiosList.vue?vue&type=script&lang=js&"
export * from "./CustomerPageVisiosList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports